<template>
  <p class="archax-footer" v-if="geoIsUK">
    {{ $t('ArchaxFooter.text.disclaimer') }}
  </p>
</template>

<script setup>
import { computed, toRef } from 'vue';
import { useGlobalStore } from '@/stores/globalStore';

const COUNTRY_CODE = 'GB';
const globalStore = useGlobalStore();
const detectedGeo = toRef(globalStore.global, 'detectedGeo');
const geoIsUK = computed(
  () => detectedGeo?.value?.country_code === COUNTRY_CODE,
);
</script>
<style lang="scss">
.archax-footer {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  margin-top: auto;
  color: var(--footer-text-color);
}
</style>
